/* The four accents a Trade vertical or one of its cards can carry. */
export const TONE_CLASSES = {
  orange: {
    eyebrow: "text-[var(--tone-orange)]",
    tag: "bg-[var(--tone-orange-bg)] text-[var(--tone-orange)]",
  },
  blue: {
    eyebrow: "text-[var(--tone-blue)]",
    tag: "bg-[var(--tone-blue-bg)] text-[var(--tone-blue)]",
  },
  green: {
    eyebrow: "text-[var(--tone-green)]",
    tag: "bg-[var(--tone-green-bg)] text-[var(--tone-green)]",
  },
  gold: {
    eyebrow: "text-[var(--tone-gold)]",
    tag: "bg-[var(--tone-gold-bg)] text-[var(--tone-gold)]",
  },
};

/* Blue is the fallback, matching TONES[config.accent] || TONES.blue. */
export const toneClasses = (accent) => TONE_CLASSES[accent] || TONE_CLASSES.blue;

/* How a group lays its cards out. Transcribed from the live grid rules, with
   one addition: each collapses to a single column on narrow screens. The live
   page hard-codes `repeat(3, …)` at every width, which overflows a phone. */
export const groupGridClass = (cards = []) => {
  if (cards.some((c) => c.feature)) return "grid-cols-1 md:grid-cols-2";
  if (cards.length === 1) return "grid-cols-1 md:grid-cols-[minmax(0,560px)]";
  if (cards.length >= 3) return "grid-cols-1 sm:grid-cols-2 md:grid-cols-3";
  return "grid-cols-1 md:grid-cols-2";
};

/* The three call-to-action treatments a card can use. */
export const CTA_CLASSES = {
  buy: "bg-[var(--orange)] text-white border border-[var(--orange)] hover:bg-[var(--orange-hover)]",
  talk: "bg-white text-[var(--orange)] border-[1.5px] border-[var(--orange)] hover:bg-[var(--orange-soft)]",
  member:
    "bg-white text-[var(--member-text)] border-[1.5px] border-[var(--member-line)] hover:bg-[var(--member-bg)]",
};

export const ctaClasses = (kind) => CTA_CLASSES[kind] || CTA_CLASSES.talk;
